import React from 'react'

function Toolbox(props) {
  return (
    <div className="title mx-auto personalLinks" id="tools">
      <h1 className="title tools">Tools 🧰 </h1>
      <div>
        <img
          src="https://github.com/devicons/devicon/raw/master/icons/html5/html5-original.svg"
          alt="HTML logo"
          width="50"
          height="50"
        />
        <img
          src="https://github.com/devicons/devicon/raw/master/icons/css3/css3-plain-wordmark.svg"
          alt="CSS logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/javascript/javascript-original.svg"
          alt="JavaScript logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/react/react-original-wordmark.svg"
          alt="React logo"
          width="50"
          height="50"
        />
        <img
          src="https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_f0b606abb6d19089febc9faeeba5bc05/nodejs-development-services.png"
          alt="NodeJS logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/express/express-original.svg"
          alt="Express logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/mongodb/mongodb-plain-wordmark.svg"
          alt="MongoDB logo"
          width="50"
          height="50"
        />
        <br></br>
        <img
          src="https://icongr.am/devicon/sass-original.svg?size=128&color=currentColor"
          alt="Sass"
          width="50"
          height="50"
        />
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg"
          alt="Tailwind logo"
          width="50"
          height="50"
        />
        <img
          src="https://user-images.githubusercontent.com/18430599/38112659-491f9112-3368-11e8-8b65-1725f19a61fa.png"
          alt="Storybook logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/mysql/mysql-original-wordmark.svg"
          alt="MySQL logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/postgresql/postgresql-original-wordmark.svg"
          alt="PostgreSQL logo"
          width="50"
          height="50"
        />
        <img
          src="https://devicons.railway.app/i/graphql.svg"
          alt="GraphQL logo"
          width="50"
          height="50"
        />
        <img
          src="https://icongr.am/devicon/php-original.svg?size=128&color=currentColor"
          alt="php"
          width="50"
          height="50"
        />
        <img
          src="https://icongr.am/devicon/docker-original-wordmark.svg?size=128&color=currentColor"
          alt="Docker"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/photoshop/photoshop-line.svg"
          alt="Photoshop logo"
          width="50"
          height="50"
        />
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/c7d326b6009e60442abc35fa45706d6f30ee4c8e/icons/premierepro/premierepro-original.svg"
          alt="Premiere logo"
          width="50"
          height="50"
        />

        <br></br>
      </div>
    </div>
  )
}

export default Toolbox
